import { render } from "./Transfer.vue?vue&type=template&id=86fb9594"
import script from "./Transfer.vue?vue&type=script&lang=ts"
export * from "./Transfer.vue?vue&type=script&lang=ts"
script.render = render

export default script